// extracted by mini-css-extract-plugin
export default {"clearAll":"index_clearAll__cnHZo","clearAllText":"index_clearAllText__FfWMS"};